/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import { useEffect, useState, useRef } from 'react';
import { Form, Modal, Input, Select, TimePicker } from 'antd';

import moment from 'moment';
import { getCoursePhaseType } from '@/services/plan';

const AddEditPhase = (props) => {
  const { visible, onCancel, onOk, phaseInfo } = props;
  const [phaseForm] = Form.useForm();
  // 阶段枚举
  const [coursePhaseTypes, setCoursePhaseTypes] = useState([]);
  const formRef = useRef(null);

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  useEffect(() => {
    if (formRef.current) {
      let dm = 0;
      let ds = 0;
      if (phaseInfo?.phaseDuration > 0) {
        dm = parseInt(phaseInfo?.phaseDuration) / 60;
        ds = parseInt(phaseInfo?.phaseDuration) % 60;
      }

      let rm = 0;
      let rs = 0;
      if (phaseInfo?.phaseInterval > 0) {
        rm = parseInt(phaseInfo?.phaseInterval) / 60;
        rs = parseInt(phaseInfo?.phaseInterval) % 60;
      }

      let rtdm = 0;
      let rtds = 0;
      if (phaseInfo?.roundTrainingDuration > 0) {
        rtdm = parseInt(phaseInfo?.roundTrainingDuration) / 60;
        rtds = parseInt(phaseInfo?.roundTrainingDuration) % 60;
      }

      let rrdm = 0;
      let rrds = 0;
      if (phaseInfo?.roundRestDuration > 0) {
        rrdm = parseInt(phaseInfo?.roundRestDuration) / 60;
        rrds = parseInt(phaseInfo?.roundRestDuration) % 60;
      }

      phaseForm.setFieldsValue({
        phaseName: phaseInfo?.phaseName,
        phaseType: phaseInfo?.phaseType,
        phaseDuration: moment({ h: 0, m: dm, s: ds, ms: 0 }),
        intermission: moment({ h: 0, m: rm, s: rs, ms: 0 }),
        phaseDescription: phaseInfo?.phaseDescription,
        containRounds: phaseInfo?.containRounds,
        roundTrainingDuration: moment({ h: 0, m: rtdm, s: rtds, ms: 0 }),
        roundRestDuration: moment({ h: 0, m: rrdm, s: rrds, ms: 0 }),
      });
    }
  }, [phaseInfo]);

  useEffect(() => {
    // 计划阶段枚举
    getCoursePhaseType({ requestData: {} }).then(({ code, data, msg }) => {
      if (code === '00000') {
        const cache = data?.coursePhaseTypes?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setCoursePhaseTypes(cache);
      } else {
        message.error(msg);
      }
    });
  }, []);

  function clickOnOkAction() {
    phaseForm.validateFields().then((values) => {
      onOk({
        ...values,
        phaseId: phaseInfo.phaseId,
      });
      phaseForm.resetFields();
    });
  }

  function clickOnCancelAction() {
    phaseForm.resetFields();
    onCancel();
  }

  return (
    <Modal
      forceRender
      open={visible}
      width={800}
      title={phaseInfo.phaseId ? '编辑阶段' : '添加阶段'}
      cancelText={'取消'}
      okText={'确认'}
      onCancel={clickOnCancelAction}
      onOk={clickOnOkAction}
      getContainer={false}
    >
      <Form form={phaseForm} {...formItemLayout} ref={formRef}>
        <Form.Item
          label={'阶段名称'}
          name={'phaseName'}
          rules={[
            {
              required: true,
              message: '请输入',
            },
            {
              max: 30,
              type: 'string',
              message: '不超过30个字符',
            },
          ]}
        >
          <Input.TextArea
            // disabled={editModel}
            maxLength={30}
            showCount
            allowClear
            autoSize={true}
            placeholder="请输入"
          />
        </Form.Item>

        <Form.Item
          label={'阶段类型'}
          name={'phaseType'}
          rules={[
            {
              required: true,
              message: '请输入',
            },
          ]}
        >
          <Select
            // mode="multiple"
            placeholder={'请选择'}
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {coursePhaseTypes.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={'运动时长'}
          name={'phaseDuration'}
          help="默认为无时间上限，点击选择时间选择阶段时间上限"
        >
          <TimePicker
            showTime={{ format: 'mm:ss' }}
            showNow={false}
            secondStep={5}
            format={'mm分:ss秒'}
          />
        </Form.Item>

        <Form.Item
          label={'休息时长'}
          name={'intermission'}
          help="默认为无时间上限，点击选择时间选择阶段时间上限"
        >
          <TimePicker
            showTime={{ format: 'mm:ss' }}
            showNow={false}
            secondStep={5}
            format={'mm分:ss秒'}
          />
        </Form.Item>

        <Form.Item
          label={'阶段描述'}
          name={'phaseDescription'}
          rules={[
            {
              required: true,
              message: '请输入',
            },
            {
              max: 400,
              type: 'string',
              message: '不超过400个字符',
            },
          ]}
        >
          <Input.TextArea
            maxLength={400}
            showCount
            allowClear
            autoSize={true}
            placeholder="请输入"
          />
        </Form.Item>

        <Form.Item label={'包含轮数'} name={'containRounds'}>
          <Select
            placeholder={'请选择'}
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Select.Option value={0}>不指定</Select.Option>
            <Select.Option value={1}>1轮</Select.Option>
            <Select.Option value={2}>2轮</Select.Option>
            <Select.Option value={3}>3轮</Select.Option>
            <Select.Option value={4}>4轮</Select.Option>
            <Select.Option value={5}>5轮</Select.Option>
            <Select.Option value={6}>6轮</Select.Option>
            <Select.Option value={7}>7轮</Select.Option>
            <Select.Option value={8}>8轮</Select.Option>
            <Select.Option value={9}>9轮</Select.Option>
            <Select.Option value={10}>10轮</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={'单轮运动时长'}
          name={'roundTrainingDuration'}
          help="默认为无时间上限，点击选择时间选择阶段时间上限"
        >
          <TimePicker
            showTime={{ format: 'mm:ss' }}
            showNow={false}
            secondStep={5}
            format={'mm分:ss秒'}
          />
        </Form.Item>

        <Form.Item
          label={'单轮休息时长'}
          name={'roundRestDuration'}
          help="默认为无时间上限，点击选择时间选择阶段时间上限"
        >
          <TimePicker
            showTime={{ format: 'mm:ss' }}
            showNow={false}
            secondStep={5}
            format={'mm分:ss秒'}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditPhase;
